// Email-safe colors: high contrast on white backgrounds, no white/near-white
// (white text is invisible in email body; very light colors fail in dark mode)
export const COLORS_PALETTE = [
  "#333333", // body default
  "#213D61", // heading navy (matches mj-style)
  "#335D95", // link blue (matches mj-style)
  "#64748b", // muted
  "#ef4444", // red
  "#b45309", // amber/dark (not bright yellow - invisible on white)
  "#047857", // green/dark
  "#1d4ed8", // blue/dark
  "#6366f1", // indigo
  "#000925", // brand navy
  "#c7c7cb", // brand accent
  "#94a3b8", // slate
];

export const EMAIL_MAX_WIDTH = 600;
